import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=ed4a26e8&scoped=true"
import script from "./DialogBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=ed4a26e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a9da48997ea17d918d5b355191c5f546/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4a26e8",
  null
  
)

export default component.exports